<template>
  <nav-bar title="钢瓶托管管理" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <ul v-if="list.length" class="list">
      <cylinder-management-item
        v-for="item in list"
        :key="item.departId"
        :item="item"
        :showBtn="true"
        @click-btn="handleItemClick(item)"
      />
    </ul>
    <Empty v-else description="没有查询到钢瓶托管管理信息" />
  </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { getCylinderCustodyMessListByComId } from '@/api/steelCylinder'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'CylinderCustodyManagement', // 钢瓶托管管理
  setup() {
    // 获取钢瓶瓶托管理信息
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getCylinderCustodyMessListByComId,
      (data) => {
        list.value = data
      },
      { companyId: companyId.value }
    )
    getDataLoading()

    // 跳转
    const router = useRouter()
    const handleItemClick = ({ groupId, departId }) => {
      router.push(`/cylinderCustodyManagementDetail/${groupId}/${departId}`)
    }

    return {
      getDataLoading,
      isLoading,
      showLoading,
      list,
      companyId,
      handleItemClick
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin: 16px 16px 0 16px;
  font-size: 14px;
  color: #666;
}
</style>
